import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/lib/contexts/AuthContext'
import { SystemCardShell, SystemCardHeading, SystemCardProgress } from '@/components/shared/layout'

// Receives a JWT via ?token= (from marketing site signup modal) and signs the
// user into the app without requiring them to go through /auth again.
export default function TokenHandoff() {
  const [searchParams] = useSearchParams()
  const { setToken } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const token = searchParams.get('token')
    const isNew = searchParams.get('new') !== '0'

    // Basic sanity check — JWTs are three base64url segments separated by dots
    const looksLikeJwt = token && /^[\w-]+\.[\w-]+\.[\w-]+$/.test(token)

    if (looksLikeJwt) {
      setToken(token)
      navigate(isNew ? '/onboarding' : '/dashboard', { replace: true })
    } else {
      // Malformed or missing token — send to signup
      navigate('/auth?mode=signup', { replace: true })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SystemCardShell>
      <SystemCardHeading eyebrow="Sign in" title="Signing you in">
        Checking your sign-in link.
      </SystemCardHeading>
      <SystemCardProgress label="Verifying link" />
    </SystemCardShell>
  )
}
